<template>
    <b-card class="bg-t-dark" no-body>
        <div class="p-3">
            <b-row class="align-items-center" style="align-items: start; height: 100%; display: flex;">

                <b-col md="2" class="text-center align-items-center d-flex flex-column">
                    <b-skeleton-img no-aspect height="80px" width="120px" animation="wave"></b-skeleton-img>

                    <h5 class="mt-2 mb-0">
                        <b-skeleton width="100px" class="mx-auto" animation="wave"></b-skeleton>
                    </h5>
                </b-col>

                <b-col md="5" style="padding-bottom: 40px;">
                    <b-skeleton width="60%" animation="wave"></b-skeleton>
                    <b-skeleton width="40%" class="mt-2" animation="wave"></b-skeleton>
                </b-col>

                <b-col md="5" class="text-right"
                    style="align-items: end; justify-content: space-between; gap: 1.5rem; display: flex; flex-direction: column; min-height: 100%;">
                    <b-skeleton width="30%" class="ml-auto" animation="wave"></b-skeleton>

                    <b-skeleton type="button" width="100px" class="mt-4 ml-auto" animation="wave"></b-skeleton>
                </b-col>

            </b-row>
        </div>
    </b-card>
</template>

<script>
export default {
    name: "EquipmentCardSkeleton"
}
</script>
